import React from 'react'

const GuideforReviewers = () => {
  return (
    <div>
      <p>
        Reviewers play an integral role in maintaining the journal’s research quality. The 
        <b> double-blind peer review process</b> ensures <b>impartial and unbiased evaluation</b> 
        of all submissions.
      </p>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Reviewer Responsibilities</h4>
      <ul>
        <li>
          Evaluate manuscripts based on <b>originality, clarity, research depth, and contribution to legal studies</b>.
        </li>
        <li>Provide <b>constructive, detailed, and actionable feedback</b> to authors.</li>
        <li>Identify any <b>plagiarism, ethical issues, or inconsistencies</b> in the manuscript.</li>
        <li>Submit the review within the <b>stipulated timeline</b> (typically 2–4 weeks).</li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Review Criteria</h4>
      <p>Reviewers should carefully assess the following aspects:</p>
      <ul>
        <li><b>Legal Relevance:</b> Does the manuscript provide value to ongoing legal debates or practices?</li>
        <li><b>Methodology:</b> Is the research approach appropriate, valid, and well-explained?</li>
        <li><b>Originality:</b> Does the study present new perspectives or innovative legal interpretations?</li>
        <li><b>References & Citations:</b> Are all sources properly cited using accepted legal referencing formats?</li>
        <li><b>Language & Clarity:</b> Is the manuscript well-written, organized, and coherent?</li>
      </ul>

      <br />
      <h4 className="fw-bold text-blue font-size-21">Confidentiality & Ethical Guidelines</h4>
      <ul>
        <li>Reviewers must <b>not disclose, share, or discuss</b> manuscript content outside the review process.</li>
        <li>If a reviewer has a <b>conflict of interest</b>, they should immediately <b>decline the review request</b>.</li>
        <li>The review must be <b>objective, unbiased, and free from personal or ideological judgments</b>.</li>
      </ul>

      <p>
        Reviewers contribute significantly to ensuring the academic integrity, rigor, and excellence of the journal.
      </p>
    </div>
  )
}

export default GuideforReviewers
